// Same rule as the public website (GET /public/events): an event stays "upcoming"
// until 3 hours after its start.
const VISIBLE_AFTER_START_MS = 3 * 60 * 60 * 1000;

/**
 * Formats a 'YYYY-MM-DD' date as e.g. 'Do., 03.12.2026'.
 */
function formatDate(date: string) {
  if (!date) {
    return '';
  }
  const [year, month, day] = date.split('-').map((part) => parseInt(part, 10));
  return new Date(Date.UTC(year, month - 1, day)).toLocaleDateString('de-AT', {
    weekday: 'short',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'UTC',
  });
}

/**
 * All events, upcoming ones first (soonest first), then past ones (most recent first).
 */
// @ts-ignore
export const all = (state) => {
  const now = Date.now();
  const events = state.all.map((event: any) => {
    const startMs = Date.parse(event.start);
    return {
      ...event,
      startMs,
      dateFormatted: formatDate(event.date),
      isPast: Number.isNaN(startMs) ? false : startMs + VISIBLE_AFTER_START_MS <= now,
    };
  });
  const upcoming = events.filter((event: any) => !event.isPast)
    .sort((a: any, b: any) => a.startMs - b.startMs);
  const past = events.filter((event: any) => event.isPast)
    .sort((a: any, b: any) => b.startMs - a.startMs);
  return upcoming.concat(past);
};

// @ts-ignore
export const one = (state) => state.one;
